export default "__VITE_ASSET__DAAj0VIG__"